import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { useApi } from '@/composables/useApi';

export const useNetoperatorStore = defineStore('netoperatorStore', () => {
  const netoperator = ref();
  const { loading, apiGet } = useApi();

  const netOperatorFluvius = computed(() => ['INFRAX', 'EANDIS', 'Fluvius'].includes(netoperator.value?.netOperator));

  async function getNetOperatorByID(id, source) {
    let url = 'netoperator/';
    switch (source) {
      case 'order':
        url += `orders/${id}`;
        break;
      case 'invoice':
        url += `invoices/${id}`;
        break;
    }

    netoperator.value = await apiGet(url);
  }

  return {
    netoperator,
    netOperatorFluvius,
    loading,
    getNetOperatorByID,
  };
});
